import { fetchPageDetails } from '@/lib/api';

import { useLocalizedQuery } from './useLocalizedQuery';

import type { AccessScope } from '@/lib/auth';
import type { UseQueryOptions } from '@tanstack/react-query';

import type { PageDetails } from '@/lib/api/types';
import type { UUID } from '@/types';

export const usePageDetails = (
  siteId: UUID | undefined,
  pageId: number | undefined,
  tenantId: string | undefined,
  scope: AccessScope,
  options?: Omit<UseQueryOptions<PageDetails, Error>, 'queryKey' | 'queryFn'>,
) => {
  const enabled =
    Boolean(siteId && tenantId && pageId) && (options?.enabled ?? true);

  return useLocalizedQuery<PageDetails, Error>(
    ['page-details', siteId, pageId, tenantId, scope],
    (locale: string) =>
      fetchPageDetails(siteId!, pageId!, tenantId!, { scope, locale }),
    { ...options, enabled },
  );
};
